<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb :breadcrumbs="breadcrumbs" />

      <div v-if="client !== null">
        <div v-if="!loading">
          <div v-if="policies.length > 0">
            <div :id="`policy-${i}`" v-for="(policy, i) in policies" :key="i" class="tw-shadow-lg tw-rounded-lg mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-8">
              <div v-if="isInstalmentDue(policy.paymentSchedule)" class="tw-mt-3">
                <div class="tw-w-full tw-px-4 md:tw-px-8">
                  <div class="tw-w-full md:tw-w-1/2 tw-flex tw-items-center tw-bg-orange-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-full tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between" role="alert">
                    <p class="c-yellow-text tw-italic tw-text-xs md:tw-text-sm"><v-icon color="secondary">mdi-volume-high</v-icon> Your Policy instalment due for payment.</p>
                    <router-link :to="{ name: 'InstalmentPayment', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }}" class="tw-bg-orange-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-full tw-text-xs md:tw-text-sm tw-cursor-pointer">PAY INSTALMENT</router-link>
                  </div>
                </div>
              </div>
              <div class="tw-w-full tw-flex tw-text-center md:tw-text-left">
                <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
                  <div class="tw-flex tw-px-2 md:tw-px-4 xl:tw-px-4 tw-items-center">
                    <img src="/images/icons/car-g.png" alt="car icon">
                    <div class="tw-px-2 md:tw-px-3 lg:tw-px-4">
                      <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">{{ policy.coverType.replace('Insurance','') }}
                        <br>Insurance</h3>
                      <p class="c-blue-text tw-text-sm tw-mt-2 md:tw-mt-4"> {{policy.risks[0].model }}, {{ policy.risks[0].regno.toUpperCase() }}</p>
                    </div>
                  </div>
                  <div class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-4 tw-border-r-0 md:tw-border-r-2 tw-border-gray-400 tw-border-l-0 md:tw-border-l-2 tw-border-gray-400 tw-mt-5 md:tw-mt-0">
                    <h3 class="c-gray-text c-title tw-text-base md:tw-text-xl">Policy Number:</h3>
                    <h3 class="c-blue-text c-title tw-text-base md:tw-text-xl">{{ policy.policyNo }}</h3>
                  </div>
                  <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0 tw-flex tw-flex-col tw-items-center">
                    <h4 class="c-gray-text tw-text-base tw-w-full"> <strong>Start Date:</strong>{{ policy.wef | formatDate }}</h4>
                    <h4 v-if="policy.productCode === 702 && policy.paymentSchedule" :class="['tw-text-base tw-w-full tw-mt-0 md:tw-mt-3', diffDate(policy.renewalDate) ? 'tw-text-red-500' : 'c-blue-text']">
                      <strong>Next Instalment:</strong>{{ scanObject(policy, 'paymentSchedule.0.dueDate')  }}
                    </h4>
                    <h4 :class="['tw-text-base tw-w-full tw-mt-0 md:tw-mt-3', diffDate(policy.renewalDate) ? 'tw-text-red-500' : 'c-blue-text']">
                      <strong>Renewal Date:</strong>{{ policy.renewalDate | formatDate }}
                    </h4>
                  </div>
                </div>
              </div>
              <div class="tw-w-full tw-flex tw-justify-end tw-mt-2 md:tw-mt-3 space-x-4">
                <span v-if="policy.toRenew">
                  <router-link :to="{ name: 'RenewPolicy', params: { policyNo: policy.policyNo, batchNo: policy.batchNo }}"> <span class="c-yellow-text">Renew Policy</span><v-icon color="secondary">mdi-chevron-right</v-icon></router-link> &nbsp; &nbsp; &nbsp;
                </span>
                <router-link :id="`view-policy-${i}`" :to="{name: 'SinglePolicy', params: {policyNo: policy.policyNo}}"><span class="c-yellow-text">View Policy</span><v-icon color="secondary">mdi-chevron-right</v-icon></router-link>
              </div>
            </div>
          </div>
          <v-card v-else class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center tw-py-24 tw-mt-4 md:tw-mt-8">
            <div class="tw-w-full tw-flex tw-justify-center">
              <v-icon size="100">mdi-file</v-icon>
            </div>
            <p class="tw-text-2xl tw-mt-10">No Policies yet !</p>
          </v-card>
        </div>
        <div v-else class="tw-w-full tw-flex tw-justify-center">
          <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </div>
      </div>
      <div class="tw-w-full tw-mt-5 md:tw-mt-10" v-else>
        <v-card v-if="!$store.state.clientLoading" class="tw-w-full tw-flex tw-flex-wrap tw-text-center tw-justify-center tw-py-24">
          <div class="tw-w-full tw-flex tw-justify-center">
            <v-icon size="100">mdi-file</v-icon>
          </div>
          <p class="tw-text-2xl tw-mt-10">No Policies yet !</p>
        </v-card>
        <div v-else class="tw-w-full tw-flex tw-justify-center">
          <v-progress-circular
              :size="40"
              color="primary"
              indeterminate
          ></v-progress-circular>
        </div>
      </div>
    </div>
  </default>
</template>

<script>
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import Default from '@/components/layout/Default';
import axios from 'axios';
import moment from 'moment';
import { diffDate, isInstalmentDue } from '@/utils/time';

export default {
  name: 'MyPolicies',
  components: { BreadCrumb, Default },
  data() {
    return {
      breadcrumbs: [
        {
          text: 'My Policies',
          disabled: true,
          to: { name: 'MyPolicies' },
        },
      ],
      policies: [],
      page: 0,
      loading: true,
    };
  },
  computed: {
    client() {
      return this.$store.getters.clientData;
    },
  },
  mounted() {
    this.init();
  },
  updated() {
    this.init();
  },
  metaInfo: {
    title: 'My Policies',
  },
  methods: {
    init() {
      if (!this.$store.state.clientLoading && this.page === 0 && this.client !== null) this.getPolicies(`/customer/gis/policies/client/productGroup/70?clientCode=${this.client.clientCode}&pageNumber=1&limit=10`);
    },
    getPolicies(url) {
      axios.get(url)
        .then((response) => {
          this.policies = response.data.object.pageItems;
          this.page += 1;
          this.loading = false;
        });
    },
    diffDate,
    isInstalmentDue,
  },
  filters: {
    formatDate(date) {
      return moment(date, 'YYYY-MM-DD').format('Do MMM YYYY');
    },
  },
};
</script>

<style>
.v-application p {
   margin-bottom: 0px!important;
}
</style>
